import { render } from "./VirtualDressingPage.vue?vue&type=template&id=4d1b7708&scoped=true"
const script = {}

import "@/assets/css/cases.css?vue&type=style&index=0&id=4d1b7708&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1b7708"]])

export default __exports__